import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8e58f3fe"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "advantage"
};
var _hoisted_2 = {
  class: "advantage_left"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "advantage_left_title_01"
  }, "企业优势", -1);
});

var _hoisted_4 = {
  class: "advantage_left_title_02"
};
var _hoisted_5 = {
  class: "advantage_left_text"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "bottom_jump_detail"
};
var _hoisted_8 = {
  class: "advantage_right"
};
var _hoisted_9 = {
  class: "advantage_right_ring"
};
var _hoisted_10 = {
  style: {
    "position": "relative"
  }
};
var _hoisted_11 = ["onClick", "src"];
var _hoisted_12 = {
  class: "row_advantage_right_ring container col-md-12 col-sm-12 col-xs-12"
};
var _hoisted_13 = ["onClick", "src"];

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "semi_circle"
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString($setup.pordetail.title), 1), _createElementVNode("div", _hoisted_5, _toDisplayString($setup.pordetail.content), 1), _createElementVNode("img", {
    src: $setup.pordetail.imageUrl,
    class: "advantage_left_img"
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "bottom_jump_detail_text",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.jumpMore && $setup.jumpMore.apply($setup, arguments);
    })
  }, "了解更多 >>")])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.porateAdvantageList, function (item) {
    return _openBlock(), _createElementBlock("img", {
      onClick: function onClick($event) {
        return $setup.roundClick(item.sortNo);
      },
      key: item.sortNo,
      src: item.iconUrl,
      class: _normalizeClass(['round_0' + item.sortNo, $setup.roundIndex == item.sortNo ? 'round_0' + item.sortNo + '_active' : ''])
    }, null, 10, _hoisted_11);
  }), 128))])]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.porateAdvantageList, function (item) {
    return _openBlock(), _createElementBlock("img", {
      onClick: function onClick($event) {
        return $setup.roundClick(item.sortNo);
      },
      key: item.sortNo,
      src: item.iconUrl,
      class: "ring_item"
    }, null, 8, _hoisted_13);
  }), 128))]), _hoisted_14])])]);
}